/**
 * @copyright 2019 @ DigiNet
 * @author TRIHAO
 * @create 11/5/2019
 * @Example 
 */
import React, {Component} from 'react';
import {Snackbar, SnackbarContent} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from "diginet-core-ui/theme";
import clsx from "clsx";
import PropTypes from 'prop-types';
import Config from "../../../config";

const useStyles = makeStyles({
    minWidth: {
        minWidth: '60%'
    },
});

class Notify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            type: "",
            time: 0,
            message: ""
        };
    }

    show = (type, message, time, cbClose) => {
        this.setState({
            show: true,
            type: type,
            time: time ? time : 0,
            message: message,
            cbClose: ()=>{
                this.setState({show: false});
                cbClose && cbClose();
            },
        });
    };

    onClose = () => {
        this.setState({show: false});
    };

    render() {
        const classes = useStyles();
        const {show, type, time, message} = this.state;
        const {minWidth, icon, anchorVertical, anchorHorizontal} = this.props;

        return (
            <Snackbar
                style={{minWidth: '100%'}}
                anchorOrigin={{
                    vertical: anchorVertical ? anchorVertical : 'bottom',
                    horizontal: anchorHorizontal ? anchorHorizontal : 'center',
                }}
                open={show}
                autoHideDuration={time}
                TransitionComponent={Config.popupTransition}
                onClose={this.onClose}
            >
                <SnackbarContent
                    className={clsx(classes[type], !minWidth ? classes.minWidth : "")}
                    style={{...(minWidth ? {minWidth: minWidth} : {})}}
                    aria-describedby="client-snackbar"
                    role={'alertdialog'}
                    message={
                        <span id="client-snackbar">
                            {icon && typeof icon === "function" ? icon() : icon}
                            {message}
                        </span>
                    }
                    action={[
                        <IconButton key="close" aria-label="close" color="inherit" onClick={this.onClose}>
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
            </Snackbar>
        );
    }
}

Notify.propTypes = {
    icon: PropTypes.any,
    minWidth: PropTypes.any,
    anchorVertical: PropTypes.string,
    anchorHorizontal: PropTypes.string
};

export default Notify;